import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import Chip from '@material-ui/core/Chip';
import { green, red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';

import { Typography, CardContent } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ReplyIcon from '@material-ui/icons/Reply';

import DriversService from './../../../services/api/drivers';

const useStyles = makeStyles({
  table: {
    marginTop: '10px',
  },
  cardContent: {
    padding: '0px !important',
  },
  card: {
    marginTop: '1rem',
  },
  chipActive: {
    backgroundColor: green[100],
    color: green[700],
  },
  chipInactive: {
    backgroundColor: red[100],
    color: red[700],
  },
});

export const DriversDetail = () => {
  const classes = useStyles();

  let { driverId } = useParams();

  const [driver, setDriver] = React.useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    setTimeout(function () {
      //Request
      DriversService.get(driverId)
        .then((response) => {
          if (response === null || !response.IsValid) {
            throw response.Message;
          }
          setIsLoading(false);
          //Get Routes
          if (response && response.Data !== undefined) {
            setDriver(response.Data);
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });
    }, 1000);
  }, [driverId]);

  return (
    <React.Fragment>
      <Card style={{ background: '#f4f6f8' }}>
        <CardContent>
          {isLoading ? (
            <Skeleton count={1} height={50} />
          ) : (
            <Grid
              container
              spacing={2}
              direction="row"
              alignContent="center"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs={9}>
                <Typography variant="h6" display="block" gutterBottom>
                  {driver.Nombre}
                </Typography>
                <Typography variant="caption" display="block" gutterBottom>
                  ID: {driver.UsuarioID}
                </Typography>
              </Grid>
              <Grid>
                <Tooltip title="Regresar">
                  <IconButton
                    color="secondary"
                    size="medium"
                    href={`/drivers/`}
                    aria-label="back to routes"
                  >
                    <ReplyIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Editar">
                  <IconButton
                    color="secondary"
                    size="medium"
                    href={`/drivers/edit/${driver.UsuarioID}`}
                    aria-label="edit route"
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
      <Card className={classes.card} style={{ background: '#f4f6f8' }}>
        <CardContent>
          <Grid
            container
            spacing={2}
            direction="row"
            alignContent="center"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Grid item sm={12} xs={12}>
              {isLoading ? (
                <Skeleton count={10} height={50} />
              ) : (
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Typography
                          variant="overline"
                          display="block"
                          gutterBottom
                        >
                          Compañia
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {driver.NombreCliente}
                      </TableCell>
                    </TableRow>
                    <TableRow selected>
                      <TableCell>
                        <Typography
                          variant="overline"
                          display="block"
                          gutterBottom
                        >
                          Nombre de Usuario
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {driver.NombreUsuario}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography
                          variant="overline"
                          display="block"
                          gutterBottom
                        >
                          Email
                        </Typography>
                      </TableCell>
                      <TableCell align="center">{driver.Email}</TableCell>
                    </TableRow>
                    <TableRow selected>
                      <TableCell>
                        <Typography
                          variant="overline"
                          display="block"
                          gutterBottom
                        >
                          Dirección
                        </Typography>
                      </TableCell>
                      <TableCell align="center">{driver.Direccion}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography
                          variant="overline"
                          display="block"
                          gutterBottom
                        >
                          Telefono 1
                        </Typography>
                      </TableCell>
                      <TableCell align="center">{driver.Telefono1}</TableCell>
                    </TableRow>
                    <TableRow selected>
                      <TableCell>
                        <Typography
                          variant="overline"
                          display="block"
                          gutterBottom
                        >
                          Fecha Expiración
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {moment(driver.FechaExpiracion).isValid()
                          ? moment(driver.FechaExpiracion).format('DD/MM/YYYY')
                          : driver.FechaExpiracion}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography
                          variant="overline"
                          display="block"
                          gutterBottom
                        >
                          Estado
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {driver.EstaActivo ? (
                          <Chip
                            icon={<CheckIcon style={{ color: green[700] }} />}
                            label="Activo"
                            className={classes.chipActive}
                          />
                        ) : (
                          <Chip
                            icon={<CloseIcon style={{ color: red[700] }} />}
                            label="Inactivo"
                            className={classes.chipInactive}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};
